import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { formatNumber } from '../../../../Utils/Money';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTablePaymentsThird from '../../../../ThirdParties/components/DisplayThridInformation/components/paymentsFromThird/DataReactTablePaymentsThird';
import ShowPayment from '../../../../Payments/components/ShowPayment';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import { InvoiceUtils } from '../../../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import DataReactTablePaymentsByProfile from './DataReactTablePaymentsByProfile';
import reciptPdf from '../../../../Admissions/SearchAdmissions/components/ReciptPdf';
import DataReactTableReceiptsPatient from '../receiptsFromPatients/DataReactTableReceiptsPatient';


const PatientsPayments = ({ id_historia }) => {
    const [totalPayments, setTotalPayments] = useState(0);
    const [inputValue, setInputValue] = useState(0); // Abonos 
    const [load, setLoad] = useState(false);
    const [invoicesData, setInvoicesData] = useState(null);
    const [paymentById, setPaymentById] = useState(null);
    const [invoiceInfo, setInvoiceInfo] = useState(null);
    const [totalInvoice, setTotalInvoice] = useState(0);
    const [incomeToPay, setIncomeToPay] = useState(0);
    const [showPaymentPDF, setShowPaymentPDF] = useState(false);
    const [showPDFInvoice, setShowPDFInvoice] = useState(false);
    const [regimes, setRegimes] = useState(null);
    const [paymentsByPatient, setPaymentsByPatient] = useState(null); //Pagos de facturas por paciente
    const [receipts, setReceipts] = useState(null); // recibos del paciente cuando es particular
    const [receiptsByPatientFromThirdAndParticular, setReceiptsByPatientFromThirdAndParticular] = useState(null); // recibos del paciente cuando los abonos se realizaron por particular o tercero
    const [showPDFReceipt, setShowPDFReceipt] = useState(false);
    const [allPayments, setAllPayments] = useState(null);
    const [retentionsByInvoice, setRetentionsByInvoice] = useState(null);
    const [showModalPayments, setShowModalPayments] = useState(false);
    const [totalAbonos, setTotalAbonos] = useState(0);

    const profile = JSON.parse(sessionStorage.getItem('clinica'));


    useEffect(() => {
        checkInvoicesPatient();
        getNameRegime();
        loadReceipstFromPatient();
    }, [])

    useEffect(() => {
        calculateValueToPay();
    }, [paymentById, allPayments]);

    const checkInvoicesPatient = async () => {
        setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/revisar-facturas-paciente?id_historia=' + id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("FACTURAST", data);
                if (data?.facturas.length > 0) {
                    //setInvoicesData(data.facturas);
                    filterParticularInvoices(data.facturas);
                }
                else {
                    setInvoicesData(null);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
                console.error('Error:', error);
            });

    }

    const loadReceipstFromPatient = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-por-paciente-particular?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (typeof data !== '[]') {
                        resolve(data);
                        setReceipts(data);
                    } else {
                        resolve(null)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const loadReceipt = (id_admision) => {
        return new Promise((resolve, reject) => {
            let dataSend = { id_admision: id_admision }
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        resolve(data.contenido[0])
                    } else {
                        resolve(null)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }
    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    //filtra las facturas cuando son de un particular
    const filterParticularInvoices = (wholeInvoice) => {
        let invoices = wholeInvoice.filter((invoice) => invoice.tipo === 1);
        let invoicesFromThird = wholeInvoice.filter((invoice) => invoice.tipo !== 1);
        acumPaymentsToShow(invoices, invoicesFromThird)
        setInvoicesData(wholeInvoice);
        getTotalInvoices(invoices, invoicesFromThird);
    }

    const acumPaymentsToShow = async (invoicesFromParticular, invoicesFromThird) => {
        console.log("FACPART", invoicesFromParticular, "FACTHIRD", invoicesFromThird)
        let payments = [];
        let abonosPayedByPatient = [];
        let abonosByThird = [];

        // calcula la informacion de tabla de pagos cuando se han introducido al sistema
        if (invoicesFromParticular !== null && invoicesFromParticular !== undefined) {
            if (invoicesFromParticular.length > 0) {
                for (let k = 0; k < invoicesFromParticular.length; k++) {
                    const invoice = invoicesFromParticular[k];
                    if (invoice?.pagos !== null) {
                        if (invoice.pagos.length > 0) {
                            let filterPaymentsFromRetentions = filterPayments(invoice.pagos);
                            filterPaymentsFromRetentions.forEach((pay => {
                                var numberInvoice = invoice.num_fac_ter;
                                pay['num_fac_ter'] = numberInvoice;
                                pay['invoice'] = invoice;
                                payments.push(pay)
                            }))
                        }
                    }
                }
            }

            //calcula los abonos que el paciente ha hecho ya se cuando se haya hecho por particular o a través de un tercero 
            if (invoicesFromThird !== null && invoicesFromThird !== undefined) {
                if (invoicesFromParticular.length > 0) {
                    for (let j = 0; j < invoicesFromParticular.length; j++) {
                        const invoice_j = invoicesFromParticular[j];
                        let payedAbonos = calculateTotal(invoice_j);
                        if (payedAbonos.total_abonos > 0) {
                            if (invoice_j.servicios?.recibos_caja.length > 1) {
                                for (let i = 0; i < invoice_j.servicios.recibos_caja.length; i++) {
                                    const element = invoice_j.servicios.recibos_caja[i];
                                    let id_admision = element.id_admision;
                                    let recieptPayed = await loadReceipt(id_admision);
                                    if (recieptPayed !== null) {
                                        abonosPayedByPatient.push(recieptPayed);
                                    }
                                }
                            } else {
                                let id_admision = invoice_j.servicios?.recibos_caja[0].id_admision;
                                let recieptPayed = await loadReceipt(id_admision);
                                if (recieptPayed !== null) {
                                    abonosPayedByPatient.push(recieptPayed)
                                }
                            }
                        }
                    }
                }


                for (let k = 0; k < invoicesFromThird.length; k++) {
                    const invoice_k = invoicesFromThird[k];
                    let payedAbonos = calculateTotal(invoice_k);
                    if (payedAbonos.total_abonos > 0) {
                        if (invoice_k.servicios?.recibos_caja.length > 1) {
                            for (let i = 0; i < invoice_k.servicios.recibos_caja.length; i++) {
                                const element = invoice_k.servicios.recibos_caja[i];
                                let id_admision = element.id_admision;
                                let recieptPayed = await loadReceipt(id_admision);
                                if (recieptPayed !== null) {
                                    abonosByThird.push(recieptPayed);
                                }
                            }
                        } else {
                            let id_admision = invoice_k.servicios?.recibos_caja[0].id_admision;
                            let recieptPayed = await loadReceipt(id_admision);
                            if (recieptPayed !== null) {
                                abonosByThird.push(recieptPayed)
                            }
                        }
                    }
                }

            }
        }
        if (payments.length > 0) {
            setPaymentsByPatient(payments);
        } else {
            setPaymentsByPatient(null);
        }

        let wholeAbonos = [];
        let receiptsByPatient = await loadReceipstFromPatient();
        if (receiptsByPatient !== null && receiptsByPatient !== undefined) {
            let checkCancelReceipts = [];
            for (let i = 0; i < receiptsByPatient.length; i++) {
                const element = receiptsByPatient[i];
                if(!element.recibo_cancelado){
                    checkCancelReceipts.push(element);
                }
            }
            wholeAbonos = [...checkCancelReceipts, ...abonosByThird];
            sumAbonosFromReceipts(wholeAbonos);
        } else {
            wholeAbonos = abonosByThird;
            sumAbonosFromReceipts(wholeAbonos);
        }
        if (wholeAbonos.length > 0) {
            setReceiptsByPatientFromThirdAndParticular(wholeAbonos);
        } else {
            setReceiptsByPatientFromThirdAndParticular(null);
        }
    }

    const sumAbonosFromReceipts = (receipts) => {
        let sumAbonos = 0;
        if(receipts !== null && receipts !== undefined){
            sumAbonos = receipts.reduce((prev, current)=>{
                console.log("PREV", prev, "current", current);
                let totalAbono = parseInt(current.total);
                console.log("TotalAbono", totalAbono );
                return prev += totalAbono;
            }, 0)
        }
        setTotalAbonos(sumAbonos);
        return sumAbonos;
    }

    //discrimina los pagos de las retenciones
    const filterPayments = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== true);
            //setPayments(resul);
            return resul;
        }

    }

    //discrimina las retenciones de los pagos
    const filterRetentions = (allPaymentsPlusRetentions) => {
        if (allPaymentsPlusRetentions !== null && allPaymentsPlusRetentions !== undefined) {
            let resul = allPaymentsPlusRetentions.filter((element) => element.retencion !== false);
            //setPayments(resul);
            return resul;
        }

    }

    // suma todos los importes de los pagos de una factura
    const addPayments = (payments) => {
        let acc = 0;
        if (payments !== null && payments !== undefined) {
            if (payments.length > 0) {
                payments.forEach((element) => acc += element.importe)
            }
        }
        return acc;
    }

    const goToInvoice = async (num_fac_ter) => {
        try {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-numero', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ num_fac_ter: num_fac_ter })
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.factura != null) {
                    let factura = [data.factura];
                    //setSelectedInvoice(factura);
                    setInvoiceInfo(factura);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
        catch (e) {
            console.log(e);
        }
    }


    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total);
                                total_abonos += parseInt(0);
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        //setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const getTotalInvoices = (invoicesData, invoicesFromThird) => {
        let sumTotalFacturas = 0; // Acumulador cantidades de todas las facturas
        let sumPagos = 0; //Acumulador de pagos
        let sumAbonos = 0 // Acumulador de Abonos de todas las facturas  Particulares;
        let sumAbonosFromThird = 0 // Acumulador de abonos hechos por el paciente cuando las facturas no son particulares;

        //Calculo de los pagos y abonos cuando el paciente ha tomado un servicio particular
        invoicesData.forEach((invoice) => {
            let totalInvoice = calculateTotal(invoice);
            sumTotalFacturas = sumTotalFacturas + totalInvoice.total_tercero;
            let sumPayments = invoice.pagos.map((pay) => {
                let sum = 0
                sum = sum + pay.importe;
                return sum;
            }).reduce((prev, current) => prev + current, 0)

            console.log("pagos", sumPayments)
            sumPagos += sumPayments;
            sumAbonos = sumAbonos + totalInvoice.total_abonos;
        })
        //Calculo de los abonos cuando el paciente ha pagado a facturas de terceros
        invoicesFromThird.forEach((invoice) => {
            let totalInvoice = calculateTotal(invoice);
            sumAbonosFromThird += totalInvoice.total_abonos;
        })
        //console.log("ABONOSTHIRD", sumAbonosFromThird);
        setInputValue(sumAbonos + sumAbonosFromThird);
        setTotalPayments(sumPagos);
        //setTotalInvoices(sumTotalFacturas);
        if (sumTotalFacturas >= sumPagos) {
            let toPay = sumTotalFacturas - sumPagos;
            //setTotalToPay(toPay);
        }
        return sumTotalFacturas;
    }

    const getPaymentById = async (id_factura, id_pago) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/consultar?id_factura_t=' + id_factura, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("PAYMENTSBYINVOICE", data);
                let filterPaymentsFromRetention = filterPayments(data);
                let filterRetentionsFromPayments = filterRetentions(data);
                let especificPayment = filterPaymentsFromRetention.filter((pay) => pay.id_pago === id_pago);
                setAllPayments(filterPaymentsFromRetention);
                setPaymentById(especificPayment);
                setRetentionsByInvoice(filterRetentionsFromPayments);
                setShowModalPayments(true);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const getNameRegime = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'regimen-contratos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                setRegimes(data);
            })
            .catch((error) => {
                console.log(error)
            })
    };



    const calculateValueToPay = async () => {
        let incomeToPay = 0;
        //Cuando se visualiza los pagos de la factura
        if (allPayments !== null && allPayments !== undefined) {
            if (allPayments.length > 0) {
                let invoice = invoicesData.filter((invoice) => invoice.id_factura_t === allPayments[0].id_factura_t);
                //setInvoiceInfo(invoice);
                goToInvoice(invoice[0].num_fac_ter);
                console.log("FAC", invoice)
                let valueTotal = invoice[0].total;

                let totales_factura = calculateTotal(invoice[0]);
                console.log('TOTALESFAC', totales_factura);
                setTotalInvoice(totales_factura?.total_tercero);
                let valot_total_fac = totales_factura?.total_tercero;
                let valor_abonos = totales_factura?.total_abonos;

                let sumPayments = addPayments(allPayments);
                console.log("FACpagos", sumPayments);

                let sumRetentions = addPayments(retentionsByInvoice);
                if (valot_total_fac >= sumPayments + sumRetentions) {
                    let incomeToPay = valot_total_fac - (sumPayments + sumRetentions);
                    setIncomeToPay(incomeToPay);
                } else {
                    setIncomeToPay('0')
                }
            }

        }
    }

    const printPDFInvoice = async (invoice) => {
        if (invoice.factura_salud) {
            await printInternalHealthInvoice(invoice, invoice.id_tercero, invoice.num_fac_ter, invoice.folio_nota_credito, invoice.es_factura);
        } else {
            //await printInternalComercialInvoice();
        }
    }

    const printInternalHealthInvoice = async (recibos, id_tercero, num_fac_ter, folio_nota_credito, es_factura) => {
        let InvoiceUt = new InvoiceUtils();
        let idsReceipts = InvoiceUt.extractIdForReceipts(recibos);
        await InvoiceUt.getReceiptsById(idsReceipts, id_tercero, num_fac_ter, folio_nota_credito).then((res) => {

            if (res != null) {
                setShowPDFInvoice(true);
                if (res.factura.recibosCaja.length > 1) {
                    InvoiceUt.generatePDFPrevisualizationInvoices(res.factura, es_factura);
                } else {
                    InvoiceUt.generatePDFPrevisualization(res.factura, es_factura);
                }
            }
            else {
                console.log("Error consultando la Previsualizacion de la Factura");
            }

        }).catch((error) => {
            alert('Ha ocurrido un error previsualizando la Factura, es posible que se hallan facturado diferentes contratos');
            setShowPDFInvoice(false);
            console.log(error);
        });
    }

    const findNameRegime = (type) => {
        let name = '';
        if (regimes !== null && type !== null) {
            let regimeFound = regimes.find((regime) => regime.id_regimen === type);
            name = regimeFound.regimen;
        }
        return name;
    }

    const showInvoiceTotalOnTable = (invoice) => {
        let total_factura = 0;
        let totales = calculateTotal(invoice);
        if (totales !== null && totales !== undefined)
            total_factura = totales?.total_tercero;
        return total_factura;
    }

    const showInvoiceTotalAbonoOnTable = (invoice) => {
        let total_abono = 0;
        let totales = calculateTotal(invoice);
        if (totales !== null && totales !== undefined)
            total_abono = totales?.total_abonos;
        return total_abono;
    }


    const reactTableDataInvoicesBythird = {
        tableHeaderData: [{
            Header: 'FACTURA No.',
            accessor: 'num_fac_ter',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => printPDFInvoice(row.row.original)}>
                    {row.value}
                </label>
            )
        },
        /*  {
             Header: 'FECHA DE EMISIÓN',
             accessor: 'fecha_emision',
             Cell: row => (
                 <label>{moment(row.value).format('DD-MM-YYYY')}</label>
             )
         }, */
        {
            Header: 'RÉGIMEN',
            accessor: 'tipo',
            Cell: row => (
                <label>{findNameRegime(row.row.original.tipo)}</label>
            )
        },
        {
            Header: 'FECHA DE VENCIMIENTO',
            accessor: 'vencimiento',
            Cell: row => (
                <label>{moment(row.value).format('DD-MM-YYYY')}</label>
            )
        },
        /* {
            Header: 'DÍAS VENCIDOS',
            accessor: 'dias_retraso_pago',
            Cell: row => (
                <label>{row.value}</label>
            )
        }, */
        {
            Header: 'ESTADO',
            accessor: 'estado_pago',
            Cell: row => (
                <label style={{ color: colorStateInvoice(row.value) }}>{stateInvoice(row.value)}</label>
            )
        },
        {
            Header: 'TOTAL',
            accessor: 'total',
            Cell: row => (
                <label>${formatNumber(showInvoiceTotalOnTable(row.row.original))}</label>
            )
        },
        {
            Header: 'ABONO',
            Cell: row => (
                <label>${formatNumber(showInvoiceTotalAbonoOnTable(row.row.original))}</label>
            )
        },
        {
            Header: 'PAGADO',
            Cell: row => (
                <label>${formatNumber(addPayments(row.row.original.pagos))}</label>
            )
        },
        {
            Header: 'PENDIENTE',
            Cell: row => (
                <label>${formatNumber(showInvoiceTotalOnTable(row.row.original) - addPayments(row.row.original.pagos))}</label>
            )
        },
        ],
        tableRowsData: invoicesData
    };

    const goToPaymentDisplay = (payment) => {
        getPaymentById(payment.id_factura_t, payment.id_pago);
    }

    const reactTableDataPayments = {
        tableHeaderData: [{
            Header: 'PAGO No.',
            accessor: 'id_pago',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <div>
                    {
                        row.value != null && row.value ?
                            <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => goToPaymentDisplay(row.row.original)}>
                                {row.value}
                            </label>
                            : "N/a"
                    }
                </div>
            )
        },
        {
            Header: 'FACTURA',
            accessor: 'num_fac_ter',
            Cell: row => (
                <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => printPDFInvoice(row.row.original.invoice)}>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'IMPORTE',
            accessor: 'importe',
            Cell: row => (
                <label>${formatNumber(Math.ceil(row.value))}</label>
            )
        },
        {
            Header: 'MODO DE PAGO',
            accessor: 'forma_pago'
        },
        {
            Header: 'FECHA DE PAGO',
            accessor: 'fecha_pago',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        {
            Header: 'ID DE LA TRANSACCIÓN',
            accessor: 'transaccion',
        },
        {
            Header: 'NOTA',
            accessor: 'nota',
        },
        ],
        tableRowsData: paymentsByPatient
    };

    const showInLetterReceiptsState = (state_receipt, canceledReceipt) => {
        let receipts_state = '';
        if (state_receipt === 1 && canceledReceipt !== true) {
            receipts_state = 'ACTIVO'
        } else if (state_receipt === 2 && canceledReceipt !== true) {
            receipts_state = 'FACTURADO'
        } else {
            receipts_state = 'ANULADO'
        }
        return receipts_state;
    }

    const calculateSubtotalReceipt = (copago, total) => {
        try {
            let subtotal = parseInt(copago) + parseInt(total);
            return subtotal;
        }
        catch (err) {
            console.log(err);
        }
    }

    const loadBilling = async (id_admision) => {
        return new Promise((resolve, reject) => {
            var dataBilling = { id_admision: id_admision };
            console.log(dataBilling);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataBilling)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    //setBilling(data.contenido[0])
                    resolve(data.contenido[0]);
                }).catch((e) => {
                    console.log(e);
                    reject(e);
                });
        })
    }

    const loadPlan = async (billing) => {
        return new Promise((resolve, reject) => {
            var dataClose = { id_plan: billing?.id_plan };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataClose)
            }).then(response => {
                return response.json();
            }).then(data => {
                //loadDataProfile(billing, data.contenido[0], dataAdmision);
                resolve(data.contenido[0]);
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        })
    }

    const loadReceiptsByAdmission = async (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                return response.json();
            }).then(res => {
                resolve(res);
            }).catch((error) => {
                console.error('Error:', error);
                resolve([]);
            });
        })
    }

    const printReceiptData = async (receipt) => {
        let openInsideWindow = true;
        let billing = await loadBilling(receipt?.id_admision);
        let plan = await loadPlan(billing);
        let receiptsByAdmission = await loadReceiptsByAdmission(receipt?.id_admision);
        setShowPDFReceipt(true);
        reciptPdf(billing, plan, profile, receiptsByAdmission, openInsideWindow);
    }

    const reactTableDataReceipts = {
        tableHeaderData: [{
            Header: 'ID',
            accessor: 'id_recibo',
            //disableGlobalFilter: true,
        },
        {
            Header: 'RECIBO NRO.',
            accessor: 'num_recibo',
            Cell: row => (
                <div>
                    {
                        row.value != null && row.value ?
                            <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => printReceiptData(row.row.original)}>
                                {row.value}
                            </label>
                            : "N/a"
                    }
                </div>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado', /* 1. PENDIENTE, 2. FACTURADO 3.RECHAZADO O CANCELADO */
            Cell: row => (
                <label>{showInLetterReceiptsState(row.cell.row.original.estado, row.cell.row.original.recibo_cancelado)}</label>

            )
        },
        {
            Header: 'FORMA DE PAGO',
            accessor: 'forma_pago',
        },
        /* {
            Header: 'SUBTOTAL',
            Cell: row => (
                <label>${formatNumber(calculateSubtotalReceipt(row.cell.row.original.total, row.cell.row.original.valor_tercero))}</label>
            )
        }, */
        {
            Header: "ABONO",
            accessor: 'total',
            Cell: row => (
                <Fragment>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <div>
                            <label>${formatNumber(parseInt(row.value))}</label>
                        </div>
                        <div>
                            <label><b>{row.cell.row.original.tipo_pago}</b></label>
                        </div>
                    </div>
                </Fragment>
            )
        },
            /* {
                Header: "Total",
                accessor: 'valor_tercero',
                Cell: row => (
                    <label>${formatNumber(parseInt(row.value))}</label>
                )
            }, */
        ],
        tableRowsData: receiptsByPatientFromThirdAndParticular
    };


    const LoadInfo = () => {
        return (<DataReactTablePaymentsThird
            reactTableData={reactTableDataInvoicesBythird}
            getPaymentById={getPaymentById}
        />)
    }

    const LoadInfoPayments = () => {
        return (
            <DataReactTablePaymentsByProfile
                reactTableData={reactTableDataPayments}
            />
        )
    }

    const LoadInfoReceipts = () => {
        return (
            <DataReactTableReceiptsPatient
                reactTableData={reactTableDataReceipts}
            />
        )
    }

    return (
        <Fragment>
            <Col>
                <Card className='show-cards'>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>PAGOS</b></h4>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className='show-payments'>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <h4><b>Pagos Recibidos</b></h4>
                                    <h3 style={{ color: '#0084CF' }}><b>${formatNumber(totalPayments)}</b></h3>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <h4><b>Abonos</b></h4>
                                    <h3 style={{ color: '#0084CF' }}><b>${formatNumber(totalAbonos)}</b></h3>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <h4><b>Total</b></h4>
                                    <h3 style={{ color: '#0084CF' }}><b>${formatNumber(totalPayments + totalAbonos)}</b></h3>
                                </div>
                            </div>
                        </Row>
                        {/* {paymentById &&
                            paymentById.length > 0 ?
                            <Row>
                                <div className='cards-payments-display-from-profile'>
                                    {paymentById.map((paymentToInvoice) => (
                                        <ShowPayment key={paymentToInvoice.id_pago} payment={paymentToInvoice} invoiceInfo={invoiceInfo} incomeToPay={incomeToPay} invoiceToEdit={null} setShowPaymentPDF={setShowPaymentPDF} /* incomeToPayWhatsLeft={incomeToPayWhatsLeft} totalInvoice={totalInvoice} />
                                    ))
                                    }
                                </div>
                            </Row>
                            : paymentById ?
                                <div className="info-empty-profile">
                                    <h5>No hay pagos hechos a esta Factura</h5>
                                </div>
                                : null

                        } */}
                        <Row>
                            {
                                load ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : paymentsByPatient ?
                                        <Fragment>
                                            {/* <LoadInfo /> */}
                                            <LoadInfoPayments />
                                        </Fragment>
                                        :
                                        <div className="info-empty-profile">
                                            <h5>No se ha generado aún ningún Pago</h5>
                                        </div>
                            }
                        </Row>
                        <Row>
                            {
                                load ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : receiptsByPatientFromThirdAndParticular ?
                                        <Fragment>
                                            <div className='clinic-history-info'>
                                                <div>
                                                    <h4><b>PAGOS GENERADOS A TRAVÉS DE ABONOS</b></h4>
                                                </div>
                                            </div>
                                            <LoadInfoReceipts />
                                        </Fragment>
                                        :
                                        <div className="info-empty-profile">
                                            <h5>No se ha generado aún ningun recibo</h5>
                                        </div>
                            }
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {showPaymentPDF ?
                <Modal
                    open={showPaymentPDF}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPaymentPDF(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                        </iframe>
                    </div>
                </Modal>
                : null}
            {showPDFInvoice ?
                <Modal
                    open={showPDFInvoice}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFInvoice(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <iframe id="pdfV" width="1000" height="700" >
                        </iframe>
                    </div>
                </Modal>
                : null}
            {showPDFReceipt ?
                <Modal
                    open={showPDFReceipt}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFReceipt(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
            {showModalPayments == true ?
                <Fragment>
                    <Modal
                        open={showModalPayments}
                        onClose={() => {
                            setShowModalPayments(false);
                        }}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                            <div className='cards-payments-display-from-profile'>
                                {paymentById.map((paymentToInvoice) => (
                                    <ShowPayment key={paymentToInvoice.id_pago} payment={paymentToInvoice} invoiceInfo={invoiceInfo} incomeToPay={incomeToPay} invoiceToEdit={null} setShowPaymentPDF={setShowPaymentPDF} /* incomeToPayWhatsLeft={incomeToPayWhatsLeft} */ totalInvoice={totalInvoice} />
                                ))
                                }
                            </div>
                        </div>
                    </Modal>
                </Fragment>
                : null
            }
        </Fragment>
    )
}

export default PatientsPayments